// Emails already sent link here, so the path and query name are a public contract.
export const MANAGE_AUTO_ROLL_PATH = '/manage/auto-roll';
export const AUTO_ROLL_INSTRUCTION_PARAM = 'instruction';

export const manageAutoRollLink = (instructionId: string): string =>
  `${MANAGE_AUTO_ROLL_PATH}?${AUTO_ROLL_INSTRUCTION_PARAM}=${encodeURIComponent(instructionId)}`;

// The skipped-roll email builds this re-buy URL, so these query names are a public contract too.
export const PURCHASE_PATH = '/purchase';
export const REBUY_WEEKS_PARAM = 'reinvestWeeks';
export const REBUY_REPLACES_PARAM = 'replaces';

export interface RebuyPrefill {
  reinvestWeeks?: number;
  replacesAutoRollInstructionId?: string;
}

export const rebuyLink = (instructionId: string, tenorWeeks: number | null): string => {
  const params = new URLSearchParams();
  if (tenorWeeks !== null) params.set(REBUY_WEEKS_PARAM, String(tenorWeeks));
  params.set(REBUY_REPLACES_PARAM, instructionId);
  return `${PURCHASE_PATH}?${params.toString()}`;
};

const POSITIVE_INTEGER = /^[1-9][0-9]*$/;
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const readRebuyPrefill = (params: URLSearchParams): RebuyPrefill => {
  const weeks = params.get(REBUY_WEEKS_PARAM);
  const replaces = params.get(REBUY_REPLACES_PARAM);
  return {
    ...(weeks && POSITIVE_INTEGER.test(weeks) ? { reinvestWeeks: Number(weeks) } : {}),
    ...(replaces && UUID.test(replaces) ? { replacesAutoRollInstructionId: replaces } : {}),
  };
};

// Compliance wording: the client instructs and a stated rule fixes the bill. Keep it free of
// "choose", "aim", "best", "suitable" and "select", which read as discretion or advice.
export const AUTO_ROLL_ROLL_LINK_LABEL = 'How the new bill is rolled';

export const autoRollRuleParagraphs = (target: string, bill: string): string[] => [
  `When ${bill} matures, your instruction is for us to use the proceeds to buy the UK Treasury ` +
    `Bill that matures on ${target}. If that day is a bank holiday, we buy the bill that matures ` +
    'on the next working day instead.',
  'If no bill matures on that day, we buy the one that matures closest to it in the 7 days ' +
    'before. We never buy a bill that matures after that day, so your money is not tied up for ' +
    `longer than you asked. We also never buy one that matures before the Monday 4 weeks after ${bill} matures.`,
  `We place the order between 8am and 4:30pm on a working day, once the proceeds from ${bill} ` +
    'have reached your account.',
  'If no bill fits, we try again on each of the next 5 working days. If there is still no match, ' +
    'the proceeds stay in your cash balance, auto-roll ends and we email you.',
  'The new bill is bought at the yield available on the day, so it may be higher or lower than ' +
    `${bill}'s. We email you 7 days before each roll and after each purchase.`,
];

// The engine re-reads the instruction when it places the order; there is no earlier cut-off yet.
export const AUTO_ROLL_STOP_TIMING =
  "You can change or stop auto-roll until the new order is placed, once the bill's maturity " +
  'proceeds are received.';
